export default "__VITE_ASSET__BtlF$LcV__"